import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  IResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRouteFunctionActivities } from "./interface/create-sub-route-function-activities.interface";
import { ICreateSubRouteFunctionActivities } from "./interface/create-sub-route-function-activities.interface copy";
import { ShortSubRouteFunctionActivityAttributes } from "@albatrosdeveloper/ave-models-package";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "sub_route_function_activity";

@Injectable({
  providedIn: "root",
})
export class SubRouteFunctionActivityService extends AbstractService<
  ShortSubRouteFunctionActivityAttributes,
  ICreateSubRouteFunctionActivities,
  IUpdateSubRouteFunctionActivities
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByFunctionId(subRouteFunctionId: string): Observable<IResult<ShortSubRouteFunctionActivityAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteFunctionId}`;
    return this.http.get<IResult<ShortSubRouteFunctionActivityAttributes>>(API_URL);
  }
}